import { FC } from 'react';
import { useFormContext, Controller } from 'react-hook-form';
import { PhoneInput, PhoneInputProps } from '../../form-controls';

export type RHFPhoneInputProps = Omit<PhoneInputProps, 'onChange'> & {
  name: string;
};

export const RHFPhoneInput: FC<RHFPhoneInputProps> = ({ name, helperText, ...other }) => {
  const { control } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState: { error } }) => (
        <PhoneInput
          {...field}
          name={name}
          fullWidth
          value={field.value}
          error={!!error}
          helperText={error ? error?.message : helperText}
          onChange={(value) => field.onChange({ target: { value } })}
          {...other}
        />
      )}
    />
  );
};
